import React from 'react';
import PropTypes from 'prop-types';
import { Flexbox } from '@piconetworks/pkg-box';
import ProductPreviewCard from './ProductPreviewCard.js';
import styles from './Products.module.scss.js';

var ProductsPreview = function ProductsPreview(_ref) {
  var _ref$addedProducts = _ref.addedProducts,
    addedProducts = _ref$addedProducts === void 0 ? [] : _ref$addedProducts,
    contributionLanguage = _ref.contributionLanguage,
    products = _ref.products,
    isPageConsolidationEnabled = _ref.isPageConsolidationEnabled,
    isPaymentLP = _ref.isPaymentLP;
  var productList;
  if (isPageConsolidationEnabled && !isPaymentLP) {
    productList = products;
  } else {
    var formProductIds = addedProducts.map(function (product) {
      return product.id;
    });
    var formProducts = [];
    products.forEach(function (product) {
      var correspondingIndex = formProductIds.indexOf(product.id);
      if (correspondingIndex !== -1) {
        var correspondingOptions = addedProducts[correspondingIndex].options;
        formProducts.push(Object.assign({}, product, {
          options: correspondingOptions
        }));
      }
    });
    formProducts = formProducts.sort(function (a, b) {
      return formProductIds.indexOf(a.id) - formProductIds.indexOf(b.id);
    });
    productList = formProducts;
    if (!products.length) {
      return null;
    }
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Flexbox.Container, {
    flexDirection: "column",
    className: styles.productPreview_container
  }, productList.map(function (product, idx) {
    return /*#__PURE__*/React.createElement(ProductPreviewCard, {
      contributionLanguage: contributionLanguage,
      key: "product-" + idx,
      previewMode: true,
      product: product
    });
  })));
};
ProductsPreview.propTypes = {
  addedProducts: PropTypes.array,
  contributionLanguage: PropTypes.string,
  products: PropTypes.array
};
var ProductsPreview$1 = /*#__PURE__*/React.memo(ProductsPreview);

export { ProductsPreview$1 as default };
//# sourceMappingURL=index.js.map
